export const DATA_HEAP_ID = 'share-event-button';
